// Module
var code = `<inline-panel on-hide="\$ctrl.onHide()">
  <div class="inline-panel__container"
       ng-repeat="keyValueItem in \$ctrl.keyValueDetails(\$ctrl.item)">
    <label class="inline-panel__label">{{keyValueItem.label}}:</label>
    <p class="inline-panel__value">{{keyValueItem.value}}</p>
  </div>
  <div ng-hide="\$ctrl.onlyData" class="inline-panel-footer" ng-if="\$ctrl.isLoanActive()">
    <button type="button"
            command-access="WaiveLoan"
            class="btn btn-info"
            ng-disabled="!\$ctrl.item.id || \$ctrl.waiveDisabled(\$ctrl.item.id)"
            ng-click="\$ctrl.waive(\$ctrl.item.id)">
      Waive
    </button>
  </div>
</inline-panel>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/amortization/amortization-inline-panel.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;